type Callback = (...args: any[]) => Promise<any>;

export const retryable: CurriedFn2<number, Callback, Callback> = (
  maxTryCount: number,
  callback?: Callback
) => {
  if (!callback) return retryable.bind(null, maxTryCount);

  return (...args: any[]) => {
    return new Promise(async (resolve, reject) => {
      let tryCount = 0;

      while (tryCount++ < maxTryCount) {
        try {
          const result = await callback(...args);
          resolve(result);
        } catch {
          if (tryCount !== maxTryCount) continue;
          reject(Error('Max try count reached'));
        }
      }
    });
  };
};



// WEBPACK FOOTER //
// ./src/utils/retryable/retryable.ts